
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import store from "./components/common/Store/store";
import { ModelDataProvider } from "./pages/CreateModel/DataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ModelDataProvider>
          <App />
        </ModelDataProvider>       
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// recent change
// import React from "react";
// import ReactDOM from "react-dom/client";
// import { Provider } from 'react-redux';
// import "./index.css";
// import App from "./App";
// import { BrowserRouter } from "react-router-dom";
// import store from "./components/common/Store/store";
// import { ModelDataProvider } from "./pages/CreateModel/DataContext";

// // const store = configureStore({ reducer: rootReducer });

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <Provider store={store}>
//         <ModelDataProvider>
//           <App />
//         </ModelDataProvider>
//       </Provider>
//     </BrowserRouter>
//   </React.StrictMode>
// );


// Fall back if need be
// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";

// const root = ReactDOM.createRoot(document.getElementById("root"));

// root.render(
//   <React.StrictMode>
//     <App/>
//   </React.StrictMode>
// );

